import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout/index";
import ParentView from "@/components/ParentView";
import InnerLink from "@/layout/components/InnerLink";

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect')
      }
    ]
  },
  {
    path: "/404",
    component: () => import("@/views/error/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/error/401"),
    hidden: true,
  },
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: 'index',
  //   children: [
  //     {
  //       path: 'index',
  //       // component: () => import('@/views/index'),
  //       component: () => import("@/views/eduPage/indexPage.vue"),
  //       name: 'index',
  //       meta: { title: '首页', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  {
    path: '',
    component: Layout,
    redirect: 'indexPage',
    children: [
      {
        path: 'indexPage',
        // component: () => import('@/views/index'),
        component: () => import("@/views/healthPage/indexPage"),
        name: 'index',
        meta: { title: '首页概览', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: false,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: () => import('@/views/system/user/profile/index'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true },
  {
    path: "/nutritionManage/tableView",
    name: "tableView",
    meta: {
      keepAlive: false,
      title: "食谱详情",
    },
    component: () => import("@/views/healthPage/nutritionManage/tableView.vue"),
  },
  {
    path: "/nutritionManage/tableRecipe",
    name: "tableRecipe",
    meta: {
      keepAlive: false,
      title: "食谱详情",
    },
    component: () => import("@/views/healthPage/nutritionManage/tableRecipe.vue"),
  },
  {
    path: "/",
    name: "",
    component: Layout,
    meta: { title: "", icon: "excel" },
    children: [
      {
        path: "indexPage",
        name: "indexPage",
        meta: {
          keepAlive: false,
          title: "首页概览",
        },
        component: () => import("@/views/healthPage/indexPage/index.vue"),
      },
      {
        path: "systemManage/categoryManage",
        name: "categoryManage",
        meta: {
          keepAlive: false,
          title: "分类管理",
        },
        component: () => import("@/views/healthPage/systemManage/categoryManage.vue"),
      },
      {
        path: "systemManage/gradeManage",
        name: "gradeManage",
        meta: {
          keepAlive: false,
          title: "年级管理",
        },
        component: () => import("@/views/healthPage/systemManage/gradeManage.vue"),
      },
      {
        path: "systemManage/stageManage",
        name: "stageManage",
        meta: {
          keepAlive: false,
          title: "阶段管理",
        },
        component: () => import("@/views/healthPage/systemManage/stageManage.vue"),
      },
      {
        path: "systemManage/zoneManage",
        name: "zoneManage",
        meta: {
          keepAlive: false,
          title: "区县管理",
        },
        component: () => import("@/views/healthPage/systemManage/zoneManage.vue"),
      },
      {
        path: "systemManage/schoolManage",
        name: "schoolManage",
        meta: {
          keepAlive: false,
          title: "学校管理",
        },
        component: () => import("@/views/healthPage/systemManage/schoolManage.vue"),
      },
      {
        path: "userManage/superUserManage",
        name: "superUserManage",
        meta: {
          keepAlive: false,
          title: "超级管理员",
        },
        component: () => import("@/views/healthPage/userManage/userPage.vue"),
      },
      {
        path: "userManage/zoneUserManage",
        name: "zoneUserManage",
        meta: {
          keepAlive: false,
          title: "区县管理员",
        },
        component: () => import("@/views/healthPage/userManage/userPage.vue"),
      },
      {
        path: "userManage/schoolUserManage",
        name: "schoolUserManage",
        meta: {
          keepAlive: false,
          title: "学校管理员",
        },
        component: () => import("@/views/healthPage/userManage/userPage.vue"),
      },
      {
        path: "userManage/masterUserManage",
        name: "masterUserManage",
        meta: {
          keepAlive: false,
          title: "班主任",
        },
        component: () => import("@/views/healthPage/userManage/userPage.vue"),
      },
      {
        path: "userManage/teacherUserManage",
        name: "teacherUserManage",
        meta: {
          keepAlive: false,
          title: "教师",
        },
        component: () => import("@/views/healthPage/userManage/userPage.vue"),
      },
      {
        path: "userManage/parentUserManage",
        name: "parentUserManage",
        meta: {
          keepAlive: false,
          title: "家长",
        },
        component: () => import("@/views/healthPage/userManage/userPage.vue"),
      },
      {
        path: "userManage/studentUserManage",
        name: "studentUserManage",
        meta: {
          keepAlive: false,
          title: "学生",
        },
        component: () => import("@/views/healthPage/userManage/userPage.vue"),
      },
      {
        path: "classManage",
        name: "classManage",
        meta: {
          keepAlive: false,
          title: "分类管理",
        },
        component: () => import("@/views/healthPage/classManage/index.vue"),
      },
      {
        path: "resourceManage/videoManage",
        name: "videoManage",
        meta: {
          keepAlive: false,
          title: "视频",
        },
        component: () => import("@/views/healthPage/resourceManage/videoManage.vue"),
      },
      {
        path: "resourceManage/imageManage",
        name: "imageManage",
        meta: {
          keepAlive: false,
          title: "图片",
        },
        component: () => import("@/views/healthPage/resourceManage/imageManage.vue"),
      },
      {
        path: "resourceManage/fileManage",
        name: "fileManage",
        meta: {
          keepAlive: false,
          title: "课件",
        },
        component: () => import("@/views/healthPage/resourceManage/fileManage.vue"),
      },
      {
        path: "studyManage/onlineCourseManage",
        name: "onlineCourseManage",
        meta: {
          keepAlive: false,
          title: "在线课程",
        },
        component: () => import("@/views/healthPage/studyManage/onlineCourseManage.vue"),
      },
      {
        path: "studyManage/onlineCourseRecord",
        name: "onlineCourseRecord",
        meta: {
          keepAlive: false,
          title: "学习记录",
        },
        component: () => import("@/views/healthPage/studyManage/onlineCourseRecord.vue"),
      },
      {
        path: "studyManage/discussRecord",
        name: "discussRecord",
        meta: {
          keepAlive: false,
          title: "评论管理",
        },
        component: () => import("@/views/healthPage/studyManage/discussRecord.vue"),
      },
      {
        path: "studyManage/offlineCourseManage",
        name: "offlineCourseManage",
        meta: {
          keepAlive: false,
          title: "实践课程",
        },
        component: () => import("@/views/healthPage/studyManage/practiceCourseManage.vue"),
      },
      {
        path: "studyManage/paraticeCourseRecord",
        name: "paraticeCourseRecord",
        meta: {
          keepAlive: false,
          title: "学习记录",
        },
        component: () => import("@/views/healthPage/studyManage/paraticeCourseRecord.vue"),
      },
      {
        path: "studyManage/studyPlanManage",
        name: "studyPlanManage",
        meta: {
          keepAlive: false,
          title: "学习计划",
        },
        component: () => import("@/views/healthPage/studyManage/planCourseManage.vue"),
      },
      {
        path: "studyManage/planCourseRecord",
        name: "planCourseRecord",
        meta: {
          keepAlive: false,
          title: "学习记录",
        },
        component: () => import("@/views/healthPage/studyManage/planCourseRecord.vue"),
      },
      {
        path: "newsManage/indexLunboManage",
        name: "indexLunboManage",
        meta: {
          keepAlive: false,
          title: "首页轮播图",
        },
        component: () => import("@/views/healthPage/newsManage/index.vue"),
      },
      {
        path: "newsManage/noticeNewsManage",
        name: "noticeNewsManage",
        meta: {
          keepAlive: false,
          title: "最新资讯",
        },
        component: () => import("@/views/healthPage/newsManage/index.vue"),
      },
      {
        path: "newsManage/securityNewsManage",
        name: "securityNewsManage",
        meta: {
          keepAlive: false,
          title: "安全报道",
        },
        component: () => import("@/views/healthPage/newsManage/index.vue"),
      },
      {
        path: "newsManage/policyNewsManage",
        name: "policyNewsManage",
        meta: {
          keepAlive: false,
          title: "政策文件",
        },
        component: () => import("@/views/healthPage/newsManage/index.vue"),
      },
      {
        path: "newsManage/otherNewsManage",
        name: "otherNewsManage",
        meta: {
          keepAlive: false,
          title: "其他资源",
        },
        component: () => import("@/views/healthPage/newsManage/index.vue"),
      },
      {
        path: "newsManage/userAgreement",
        name: "userAgreement",
        meta: {
          keepAlive: false,
          title: "用户协议",
        },
        component: () => import("@/views/healthPage/newsManage/index.vue"),
      },
      {
        path: "surveyManage/surveyBank",
        name: "surveyBank",
        meta: {
          keepAlive: false,
          title: "问卷库",
        },
        component: () => import("@/views/healthPage/surveyManage/index.vue"),
      },
      {
        path: "surveyManage/healthSurvey",
        name: "healthSurvey",
        meta: {
          keepAlive: false,
          title: "健康问卷",
        },
        component: () => import("@/views/healthPage/surveyManage/healthSurvey.vue"),
      },
      {
        path: "testPage",
        name: "testPage",
        meta: {
          keepAlive: false,
          title: "测试页面",
        },
        component: () => import("@/views/testPage"),
      },
      {
        path: "nutritionManage/mealType",
        name: "mealType",
        meta: {
          keepAlive: false,
          title: "餐食类型",
        },
        component: () => import("@/views/healthPage/nutritionManage/mealType.vue"),
      },
      {
        path: "nutritionManage/nutritionPlan",
        name: "nutritionPlan",
        meta: {
          keepAlive: false,
          title: "带量食谱",
        },
        component: () => import("@/views/healthPage/nutritionManage/nutritionPlan.vue"),
      },
      {
        path: "nutritionManage/food",
        name: "food",
        meta: {
          keepAlive: false,
          title: "菜谱/食谱",
        },
        component: () => import("@/views/healthPage/nutritionManage/food.vue"),
      },
      {
        path: "healthManage/studentHealth",
        name: "studentHealth",
        meta: {
          keepAlive: false,
          title: "学生健康",
        },
        component: () => import("@/views/healthPage/healthManage/studentHealth.vue"),
      },
      {
        path: "healthManage/zoneHealth",
        name: "zoneHealth",
        meta: {
          keepAlive: false,
          title: "区县健康",
        },
        component: () => import("@/views/healthPage/healthManage/zoneHealth.vue"),
      },
      {
        path: "healthManage/schoolHealth",
        name: "schoolHealth",
        meta: {
          keepAlive: false,
          title: "学校健康",
        },
        component: () => import("@/views/healthPage/healthManage/schoolHealth.vue"),
      },
      {
        path: "taskCenter/excelData",
        name: "excelData",
        meta: {
          keepAlive: false,
          title: "数据导入导出",
        },
        component: () => import("@/views/healthPage/taskCenter/excelData.vue"),
      },
      {
        path: "systemConfig/year",
        name: "year",
        meta: {
          keepAlive: false,
          title: "学年",
        },
        component: () => import("@/views/eduPage/systemConfig/year.vue"),
      },
      {
        path: "systemConfig/term",
        name: "term",
        meta: {
          keepAlive: false,
          title: "学期",
        },
        component: () => import("@/views/eduPage/systemConfig/term.vue"),
      },
      {
        path: "systemConfig/currentYearTerm",
        name: "currentYearTerm",
        meta: {
          keepAlive: false,
          title: "当前学年学期",
        },
        component: () => import("@/views/eduPage/systemConfig/currentYearTerm.vue"),
      },
      {
        path: "systemConfig/graduateYearTerm",
        name: "graduateYearTerm",
        meta: {
          keepAlive: false,
          title: "毕业学年学期",
        },
        component: () => import("@/views/eduPage/systemConfig/graduateYearTerm.vue"),
      },
      {
        path: "systemConfig/registYearTerm",
        name: "registYearTerm",
        meta: {
          keepAlive: false,
          title: "招生学年学期",
        },
        component: () => import("@/views/eduPage/systemConfig/registYearTerm.vue"),
      },
      {
        path: "editorManage",
        name: "editorManage",
        meta: {
          keepAlive: false,
          title: "图文管理",
        },
        component: () => import("@/views/eduPage/editorManage/index.vue"),
      },
      {
        path: "adminManage",
        name: "adminManage",
        meta: {
          keepAlive: false,
          title: "教务员管理员",
        },
        component: () => import("@/views/eduPage/adminManage/index.vue"),
      },
      {
        path: "schoolManage/school",
        name: "school",
        meta: {
          keepAlive: false,
          title: "学习中心",
        },
        component: () => import("@/views/eduPage/schoolManage/school.vue"),
      },
      {
        path: "schoolManage/schoolAdmin",
        name: "schoolAdmin",
        meta: {
          keepAlive: false,
          title: "学习中心管理员",
        },
        component: () => import("@/views/eduPage/schoolManage/schoolAdmin.vue"),
      },
      {
        path: "gradeManage/gradeMaster",
        name: "gradeMaster",
        meta: {
          keepAlive: false,
          title: "班主任",
        },
        component: () => import("@/views/eduPage/gradeManage/gradeMaster.vue"),
      },
      {
        path: "gradeManage/grade",
        name: "grade",
        meta: {
          keepAlive: false,
          title: "班级",
        },
        component: () => import("@/views/eduPage/gradeManage/grade.vue"),
      },
      {
        path: "registTeacherManage",
        name: "registTeacherManage",
        meta: {
          keepAlive: false,
          title: "招生教师管理",
        },
        component: () => import("@/views/eduPage/registTeacherManage/index.vue"),
      },
      {
        path: "jiaowuRegistStudent",
        name: "jiaowuRegistStudent",
        meta: {
          keepAlive: false,
          title: "国开招生信息",
        },
        component: () => import("@/views/eduPage/jiaowuRegistStudent/index.vue"),
      },
      {
        path: "ruleManage",
        name: "ruleManage",
        meta: {
          keepAlive: false,
          title: "培养方案管理",
        },
        component: () => import("@/views/eduPage/ruleManage/index.vue"),
      },
      {
        path: "collegeManage",
        name: "collegeManage",
        meta: {
          keepAlive: false,
          title: "学院管理",
        },
        component: () => import("@/views/eduPage/collegeManage/index.vue"),
      },
      {
        path: "teacherManage",
        name: "teacherManage",
        meta: {
          keepAlive: false,
          title: "教师管理",
        },
        component: () => import("@/views/eduPage/teacherManage/index.vue"),
      },
      {
        path: "registStudentManage",
        name: "registStudentManage",
        meta: {
          keepAlive: false,
          title: "招生审核管理",
        },
        component: () => import("@/views/eduPage/registStudentManage/index.vue"),
      },
      {
        path: "registStudentManage/edit",
        name: "registStudentManageEdit",
        meta: {
          keepAlive: false,
          title: "招生审核编辑",
        },
        component: () => import("@/views/eduPage/registStudentManage/edit.vue"),
      },
      {
        path: "teacherCourseManage",
        name: "teacherCourseManage",
        meta: {
          keepAlive: false,
          title: "教师课程管理",
        },
        component: () => import("@/views/eduPage/teacherCourseManage/index.vue"),
      },
      {
        path: "courseManage",
        name: "courseManage",
        meta: {
          keepAlive: false,
          title: "课程管理",
        },
        component: () => import("@/views/eduPage/courseManage/index.vue"),
      },
      {
        path: "majorManage",
        name: "majorManage",
        meta: {
          keepAlive: false,
          title: "专业管理",
        },
        component: () => import("@/views/eduPage/majorManage/index.vue"),
      },
      {
        path: "studentManage",
        name: "studentManage",
        meta: {
          keepAlive: false,
          title: "学生管理",
        },
        component: () => import("@/views/eduPage/studentManage/index.vue"),
      },
      {
        path: "studentManage/edit",
        name: "studentManageEdit",
        meta: {
          keepAlive: false,
          title: "学生管理编辑",
        },
        component: () => import("@/views/eduPage/studentManage/edit.vue"),
      },
      {
        path: "studentCourseManage",
        name: "studentCourseManage",
        meta: {
          keepAlive: false,
          title: "课程注册管理",
        },
        component: () => import("@/views/eduPage/studentCourseManage/index.vue"),
      },
      {
        path: "scoreManage/preScore",
        name: "preScore",
        meta: {
          keepAlive: false,
          title: "预发布成绩",
        },
        component: () => import("@/views/eduPage/scoreManage/preScore.vue"),
      },
      {
        path: "scoreManage/releaseScore",
        name: "releaseScore",
        meta: {
          keepAlive: false,
          title: "历次成绩",
        },
        component: () => import("@/views/eduPage/scoreManage/releaseScore.vue"),
      },
      {
        path: "graduateManage/graduateStudent",
        name: "graduateStudent",
        meta: {
          keepAlive: false,
          title: "毕业生信息",
        },
        component: () => import("@/views/eduPage/graduateManage/graduateStudent.vue"),
      },
      {
        path: "graduateManage/degreePaper",
        name: "degreePaper",
        meta: {
          keepAlive: false,
          title: "学位证领取",
        },
        component: () => import("@/views/eduPage/graduateManage/degreePaper.vue"),
      },
      {
        path: "graduateManage/graduatePaper",
        name: "graduatePaper",
        meta: {
          keepAlive: false,
          title: "毕业证领取",
        },
        component: () => import("@/views/eduPage/graduateManage/graduatePaper.vue"),
      },
      {
        path: "graduateManage/offlinePaperConfig",
        name: "offlinePaperConfig",
        meta: {
          keepAlive: false,
          title: "线下证书领取配置",
        },
        component: () => import("@/views/eduPage/graduateManage/offlinePaperConfig.vue"),
      },
      {
        path: "awardManage/studyBehavior",
        name: "studyBehavior",
        meta: {
          keepAlive: false,
          title: "学习行为",
        },
        component: () => import("@/views/eduPage/awardManage/studyBehavior.vue"),
      },
      {
        path: "awardManage/awardConfig",
        name: "awardConfig",
        meta: {
          keepAlive: false,
          title: "生成配置",
        },
        component: () => import("@/views/eduPage/awardManage/awardConfig.vue"),
      },
      {
        path: "awardManage/awardStudent",
        name: "awardStudent",
        meta: {
          keepAlive: false,
          title: "学生评优",
        },
        component: () => import("@/views/eduPage/awardManage/awardStudent.vue"),
      },
      {
        path: "affairProcess",
        name: "affairProcess",
        meta: {
          keepAlive: false,
          title: "事务处理",
        },
        component: () => import("@/views/eduPage/affairProcess/index.vue"),
      },
      {
        path: "affairProcess/add",
        name: "affairProcessAdd",
        meta: {
          keepAlive: false,
          title: "创建事务处理",
        },
        component: () => import("@/views/eduPage/affairProcess/add.vue"),
      },
      {
        path: "affairProcess/detail",
        name: "affairProcessDetail",
        meta: {
          keepAlive: false,
          title: "事务处理详情",
        },
        component: () => import("@/views/eduPage/affairProcess/detail.vue"),
      },
      {
        path: "affairProcess/auditEdit",
        name: "auditEdit",
        meta: {
          keepAlive: false,
          title: "审核编辑",
        },
        component: () => import("@/views/eduPage/affairProcess/auditEdit.vue"),
      },

      {
        path: "dataUpload",
        name: "dataUpload",
        meta: {
          keepAlive: false,
          title: "资料报送",
        },
        component: () => import("@/views/eduPage/dataUpload/index.vue"),
      },
      {
        path: "dataUpload/add",
        name: "dataUploadAdd",
        meta: {
          keepAlive: false,
          title: "创建资料报送",
        },
        component: () => import("@/views/eduPage/dataUpload/add.vue"),
      },
      {
        path: "dataUpload/detail",
        name: "dataUploadDetail",
        meta: {
          keepAlive: false,
          title: "资料报送详情",
        },
        component: () => import("@/views/eduPage/dataUpload/detail.vue"),
      },
      {
        path: "dataUpload/upLoadEdit",
        name: "upLoadEdit",
        meta: {
          keepAlive: false,
          title: "审核编辑",
        },
        component: () => import("@/views/eduPage/dataUpload/upLoadEdit.vue"),
      },

      {
        path: "roleTag",
        name: "roleTag",
        meta: {
          keepAlive: false,
          title: "选择角色",
        },
        component: () => import("@/views/eduPage/roleTag.vue"),
      },
      {
        path: "taskCenter/excelTask",
        name: "excelTask",
        meta: {
          keepAlive: false,
          title: "excel任务中心",
        },
        component: () => import("@/views/eduPage/excelTask/index.vue"),
      },
      {
        path: "taskCenter/zipTask",
        name: "zipTask",
        meta: {
          keepAlive: false,
          title: "zip任务中心",
        },
        component: () => import("@/views/eduPage/zipTask/index.vue"),
      },
      {
        path: "auditFlowCenter/auditFlowTemplate",
        name: "auditFlowTemplate",
        meta: {
          keepAlive: false,
          title: "模版配置",
        },
        component: () => import("@/views/eduPage/auditFlowCenter/auditFlowTemplate.vue"),
      },
      {
        path: "auditFlowCenter/addAuditModel",
        name: "addAuditModel",
        meta: {
          keepAlive: false,
          title: "新建模版",
        },
        component: () => import("@/views/eduPage/auditFlowCenter/addAuditModel.vue"),
      },
      {
        path: "auditFlowCenter/affairProcess",
        name: "affairProcess",
        meta: {
          keepAlive: false,
          title: "事务处理",
        },
        component: () => import("@/views/eduPage/affairProcess/index.vue"),
      },
      {
        path: "auditFlowCenter/dataUpload",
        name: "dataUpload",
        meta: {
          keepAlive: false,
          title: "资料报送",
        },
        component: () => import("@/views/eduPage/dataUpload/index.vue"),
      },
      {
        path: "messageCenter/messageSend",
        name: "messageSend",
        meta: {
          keepAlive: false,
          title: "发送消息",
        },
        component: () => import("@/views/eduPage/messageCenter/messageSend.vue"),
      },
      {
        path: "messageCenter/messageTemplate",
        name: "messageTemplate",
        meta: {
          keepAlive: false,
          title: "模版配置",
        },
        component: () => import("@/views/eduPage/messageCenter/messageTemplate.vue"),
      },
      {
        path: "jobManage",
        name: "jobManage",
        meta: {
          keepAlive: false,
          title: "作业管理",
        },
        component: () => import("@/views/eduPage/jobManage"),
      },
    ],
  }
];

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [

];

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((err) => err);
};

export default new Router({
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.VUE_APP_BASE_URL,
  routes: dynamicRoutes.concat(constantRoutes),
});
